const Home = () => {

  return (
    <div className="w-full h-full flex-center px-4 bg-primary pt-[108px]">
      <p className="w-full h-full flex-center text-center text-[calc(23vw-0.4rem)] font-black tracking-tighter overflow-auto">
        SUMMER
      </p>
    </div>
  );
}

export default Home;